import { ISaveDocumentBeneficiaryBody, ISaveDocumentBody } from "utils/interfaces";
import { talentoApi } from "./index";

const filesExtensionApi = talentoApi.injectEndpoints({
  endpoints: (builder) => ({
    saveDocument: builder.mutation<{ url: string }, ISaveDocumentBody>({
      query: (body) => ({
        url: `/files/files`,
        method: 'POST',
        body,
      }),
    }),

    saveDocumentBeneficiaryInHiring: builder.mutation<
      { [key: string]: string },
      ISaveDocumentBeneficiaryBody
    >({
      query: (body) => ({
        url: `/files/files/beneficiary`,
        method: 'POST',
        body,
      }),
    }),

    presignedUrl: builder.mutation<{ 
      uploadPresignedUrl: string;
      downloadPresignedUrl: string;
      fileKey: string;
    }, { fileName: string }>({
      query: (params) => ({
        url: `/files/files/presigned-urls-by-file?fileName=${params.fileName}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_id')}`,
        },
      }),
    }),
  }),
});

export const {
  useSaveDocumentMutation,
  useSaveDocumentBeneficiaryInHiringMutation,
  usePresignedUrlMutation,
} = filesExtensionApi;